import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'

const Icici733BalanceUpdateModalUI = ({ context, successMsg, errorList, setErrorList,
  // modes
  updateMode, submitted,
  // handlers
  onSubmit, onCancelClick,
  // fields
  updatedBalance, onUpdatedBalanceChange, updatedBalanceError, setUpdatedBalanceError
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Update 733 Balance'
    buttonLabel='Update'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputTextSF type='text' name='updatedBalance' required={true}
      label='Current Balance in 733'
      value={updatedBalance} onChange={onUpdatedBalanceChange}
      error={updatedBalanceError} setError={setUpdatedBalanceError}
      autoFocus={true}
    />
  </ModalFormUI>

export default Icici733BalanceUpdateModalUI


